import {useIntl} from 'react-intl';
import * as React from 'react';
import {useEffect, useRef, useState} from 'react';
import {DynamicForm} from "@xal3xfx/react-utils";
import {formElements} from "./add-iban-form";
import {ClientService} from "../../../../lib/services/client-service";
import {useToast} from "../../../../lib/hooks/useToast";
import {AddIbanToClientRequest} from "../../../../lib/types/types";
import useSWR from "swr";
import {IDropdownOption} from "@xal3xfx/react-utils/dist/util-service";

interface Props {
    iban?: string;
    clientNameSuggestion?: string;
    onCreatedCb?: () => void
}

const initialValues: AddIbanToClientRequest = {
    clientId: undefined,
    iban: ""
}

const AddIBAN: React.FC<Props> = props => {
    const {formatMessage: f} = useIntl();
    const didMountRef = useRef(false);
    const toastHelpers = useToast();

    const [formElementsState, setFormElementsState] = useState({...formElements});
    const [formData, setFormData] = useState({...initialValues});

    const clientService = new ClientService(f, toastHelpers);
    const {data: clientOptions} = useSWR<IDropdownOption[], Error>('/clients/dropdown');

    useEffect(() => {
        if (!didMountRef.current) {
            didMountRef.current = true;
        }
    }, []);

    useEffect(() => {
        if(!clientOptions) return;
        const tempFormElements = {...formElementsState};
        tempFormElements.clientId.options = clientOptions;
        setFormElementsState({...tempFormElements});
    }, [clientOptions]);

    useEffect(() => {
        if(!props.iban) return;
        setFormData(prevState => {
            return {...prevState, iban: props.iban!}
        });
    }, [props.iban])

    useEffect(() => {
        if(!props.clientNameSuggestion || !clientOptions) return;
        const suggestedClient = clientOptions.find(client => client.description?.toLowerCase() === props.clientNameSuggestion?.toLowerCase())
        if(suggestedClient) {
            setFormData(prevState => {return {...prevState, clientId: suggestedClient.id as number}});
        }
    }, [props.clientNameSuggestion, clientOptions])

    const handleCreate = (data: AddIbanToClientRequest) => {
        return new Promise<boolean>((resolve, reject) => {
            if (!data.clientId || !data.iban || data.iban.length === 0) {
                reject(false);
                return;
            }
            clientService.addIbanToClient(data.clientId, data.iban)
                .then(resp => {
                    if(resp){
                        toastHelpers.showToast('success', f({id: 'operationSuccessful'}), "");
                        if(props.onCreatedCb) {
                            props.onCreatedCb();
                        }
                    }
                    resolve(resp)
                }).catch(err => {
                    toastHelpers.showToast('warn', f({id: 'operationUnsuccessful'}), f({id: ''}))
                    reject(false);
            })
        })
    }


    return <>
        <DynamicForm formElements={formElementsState} isUpdate={false} onCreate={handleCreate} rowClassName={"col-12 md:col-6"}
                     onUpdate={() => Promise.resolve(true)} initialValues={formData} fieldOrder={['clientId', 'iban']}
                     onCancelUpdate={() => 0}/>

    </>

};

export default AddIBAN
